import { createAsyncTypes } from 'utils/ActionCreator'

const typeKey = 'ScenarioForm'

export const GET_SCENARIO_ASYNC = createAsyncTypes('GET_SCENARIO', typeKey)
export const ADD_SCENARIO_ASYNC = createAsyncTypes('ADD_SCENARIO', typeKey)
export const SAVE_SCENARIO_ASYNC = createAsyncTypes('SAVE_SCENARIO', typeKey)
export const DELETE_SCENARIO_ASYNC = createAsyncTypes('DELETE_SCENARIO', typeKey)
export const REPORT_TO_TEMPLATE_ASYNC = createAsyncTypes('REPORT_TO_TEMPLATE', typeKey)
export const GET_AWARENESS_DETAILS_ASYNC = createAsyncTypes('GET_AWARENESS_DETAILS', typeKey)
export const CREATE_CAMPAIGN_FROM_INCIDENTS_ASYNC = createAsyncTypes(
  'CREATE_CAMPAIGN_FROM_INCIDENTS_ASYNC',
  typeKey
)
export const CREATE_CAMPAIGN_FROM_SCENARIO_ASYNC = createAsyncTypes(
  'CREATE_CAMPAIGN_FROM_SCENARIO',
  typeKey
)

export const RESET_MANAGER = `${typeKey}/RESET_MANAGER`
export const CHANGE_SCENARIO_PROPERTY = `${typeKey}/CHANGE_SCENARIO_PROPERTY`
export const CHANGE_SCENARIO_CONTENT = `${typeKey}/CHANGE_SCENARIO_CONTENT`
export const CHANGE_SCENARIO_LANG_VALUES = `${typeKey}/CHANGE_SCENARIO_LANG_VALUES`
export const SET_SCENARIO_WAS_LOADER = `${typeKey}/SET_SCENARIO_WAS_LOADER`

export const SCENARIO_FORM_FLOWS = {
  FROM_MANAGEMENT: 1,
  FROM_INCIDENT: 2,
  FROM_WIZARD: 3,
}

export const FILE_TYPE_OPTIONS = [
  { value: 1, label: 'html' },
  { value: 2, label: 'pdf' },
  { value: 3, label: 'docx' },
  { value: 4, label: 'xls' },
]

export const DEFAULT_SCENARIO_CONTENT = {
  body: '',
  body_hint: '',
  body_link_hint: '',
  from_email: '',
  from_number: '',
  from_address_hint: '',
  subject: '',
  subject_hint: '',
  call_for_action_page: '',
  landing_domain: '',
  landing_subdomain: '',
  folder_name: '',
  filename: '',
  filetype: 1,
  attachment_hint: '',
}

export const parseFromEmail = (fromEmail) => {
  const email = fromEmail.replace(/<|>/g, '')
  let displayName = ''

  if (email.includes(' ')) {
    displayName = fromEmail.split(' ')
    displayName = displayName.splice(0, displayName.length - 1).join(' ')
  }

  const from = email.substring(email.lastIndexOf(' ') + 1, email.lastIndexOf('@'))

  const domain = email.split('@').pop()

  return { displayName, from, domain }
}
